<template>
  <!-- bg_white bg_gray  -->
  <div v-show="showTit === '财务透视'" @click="showSeliceAll">
    <section class="main cwts_box">
      <hgroup class="mainPage financialBox" style="padding-bottom: 0">
        <header>
          主要指标
          <i class="icon-help" @click="goZyzbLink">!</i>
          <a href="javascript:void(0);" @click="goLinkMore('zyzb')"> 更多 </a>
        </header>
        <p class="info-label info-label-tab4">
          <a
            :class="zbToplistChecked == item.id ? 'aChecked' : ''"
            v-for="(item, index) in zbToplist"
            :key="index"
            @click="handleZbToplist(item.id, item.name)"
          >
            {{ item.name }}
          </a>
        </p>
        <div class="canvas-wrap">
          <div class="canvas-title">
            <div class="canvas-title-group flex">
              <span class="icon-bar bar-blue">
                <i>{{ zbToplistCheckedName }}</i>
              </span>
              <span class="icon-line line-org">同比</span>
            </div>
            <div class="date-picker date-picker-s fr">
              <div class="show_name_box" @click.stop="zbSelectShow = !zbSelectShow">
                {{ zbSeliceName }}
              </div>
              <div class="select_box" v-show="zbSelectShow">
                <p
                  :class="{ cur: item.key === zb_sy_sel }"
                  v-for="item in zbSyList"
                  :key="item.key"
                  @click.stop="seliceZbSy(item)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="canvas canvas-djcw" id="bar-zyzb" style="height: 230px"></div>
        </div>
      </hgroup>
      <hgroup class="mainPage financialBox" style="padding-bottom: 0">
        <header class="noline">
          利润表
          <a href="javascript:void(0);" @click="goLinkMore('lrb')"> 更多 </a>
        </header>
        <div class="m-tab-wrap">
          <ul class="m-tab-sub">
            <li
              :class="handleChecked == item.id ? 'cur' : ''"
              v-for="(item, index) in lrbTitleList"
              :key="index"
              @click="handleCutLrb(item.id, item.title)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="canvas-wrap">
          <div class="canvas-title">
            <div class="canvas-title-group flex">
              <span class="icon-bar bar-blue">
                {{ handleCheckedTitle }}
              </span>
              <span class="icon-line line-org">同比</span>
            </div>
            <div class="date-picker date-picker-s fr">
              <div class="show_name_box" @click.stop="lrbSeliceShow = !lrbSeliceShow">
                {{ lrbSeliceName }}
              </div>
              <div class="select_box" v-show="lrbSeliceShow">
                <p
                  :class="{ cur: item.key === lrb_sy_sel }"
                  v-for="item in lrbSeliceList"
                  :key="item.key"
                  @click.stop="seliceLrb(item)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="canvas canvas-djcw" id="bar-lrb" style="height: 230px"></div>
        </div>
      </hgroup>
      <hgroup class="mainPage financialBox" style="padding-bottom: 0">
        <header class="noline">
          资产负债表
          <a href="javascript:void(0);" @click="goLinkMore('zcfz')"> 更多 </a>
        </header>
        <div class="canvas-wrap">
          <div class="canvas-title">
            <div class="canvas-title-group flex">
              <span class="icon-bar bar-blue">总资产</span>
              <span class="icon-bar bar-org">总负债</span>
              <span class="icon-line line-org">资产负债率</span>
            </div>
            <div class="date-picker date-picker-s fr">
              <div class="show_name_box" @click.stop="zcfzbSeliceShow = !zcfzbSeliceShow">
                {{ zcfzbSeliceName }}
              </div>
              <div class="select_box" v-show="zcfzbSeliceShow">
                <p
                  :class="{ cur: item.key === zcfzb_sel }"
                  v-for="item in zcfzbSeliceList"
                  :key="item.key"
                  @click.stop="seliceZcfzb(item)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="canvas canvas-djcw" id="bar-fzb" style="height: 230px"></div>
        </div>
      </hgroup>
      <hgroup class="mainPage financialBox" style="padding-bottom: 0">
        <header class="noline">
          现金流量表
          <a href="javascript:void(0);" @click="goLinkMore('xjll')"> 更多 </a>
        </header>
        <div class="canvas-wrap">
          <div class="m-tab-wrap">
            <ul class="m-tab-sub">
              <li
                :class="handleCheckedXjllb == item.id ? 'cur' : ''"
                v-for="(item, index) in xjllbTitleList"
                :key="index"
                @click="handleCutXjllb(item.id, item.title)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div class="canvas-title">
            <div class="canvas-title-group flex">
              <span class="icon-bar bar-blue">
                {{ handleCheckedTitleXjllb }}
              </span>
              <span class="icon-line line-org">同比</span>
            </div>
            <div class="date-picker date-picker-s fr">
              <div class="show_name_box" @click.stop="xjllbSeliceShow = !xjllbSeliceShow">
                {{ xjllbSeliceName }}
              </div>
              <div class="select_box" v-show="xjllbSeliceShow">
                <p
                  :class="{ cur: item.key === xjllb_sel }"
                  v-for="item in xjllbSeliceList"
                  :key="item.key"
                  @click.stop="seliceXjllb(item)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="canvas canvas-djcw" id="bar-llb" style="height: 230px"></div>
        </div>
      </hgroup>
    </section>
    <Declare v-if="affairQuery"></Declare>
  </div>
</template>

<script>
import { getEventData } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading";
import Declare from "../components/declare";
export default {
  name: "financial",
  props: ["showTit", "token"],
  data() {
    return {
      financialData: null,
      code: "",
      affairQuery: false,
      zbToplist: [
        {
          name: "每股收益",
          id: "basicepsn",
        },
        {
          name: "每股净资产",
          id: "mgjzc",
        },
        {
          name: "流动比率",
          id: "currentrt",
        },
        {
          name: "速动比率",
          id: "quickrt",
        },
        {
          name: "净利率",
          id: "npmarginonsale",
        },
        {
          name: "毛利率",
          id: "sgpmargin",
        },
        {
          name: "ROE",
          id: "roe",
        },
        {
          name: "ROA",
          id: "roa",
        },
      ],
      zbToplistChecked: "basicepsn",
      zbToplistCheckedName: "每股收益",
      zb_sy_sel: "newly",
      zbSelectShow: false,
      zbSeliceName: "最新",
      zbSyList: [
        { name: "最新", key: "newly" },
        { name: "一季度", key: "first" },
        { name: "中报", key: "middle" },
        { name: "三季度", key: "third" },
        { name: "年报", key: "annal" },
      ],
      zyzbMgsyListAll: [],
      zyzbMgsyList: [],
      zyzbAsOfDateList: [],
      zyzbTbList: [],
      zyzbDom: null,
      zyzbText: "加载中",
      lrbTitleList: [
        {
          title: "营业总收入",
          id: "biztotinco",
        },
        {
          title: "营业利润",
          id: "perprofit",
        },
        {
          title: "净利润",
          id: "netprofit",
        },
      ],
      lrbMgsyListAll: [],
      lrbMgsyList: [],
      lrbAsOfDateList: [],
      lrbTbList: [],
      handleChecked: "biztotinco",
      handleCheckedTitle: "营业总收入",
      lrb_sy_sel: "newly",
      lrbSeliceShow: false,
      lrbSeliceName: "最新",
      lrbSeliceList: [
        { name: "最新", key: "newly" },
        { name: "一季度", key: "first" },
        { name: "中报", key: "middle" },
        { name: "三季度", key: "third" },
        { name: "年报", key: "annal" },
      ],
      lrbDom: null,
      lrbText: "加载中",
      zcfzb_sel: "newly",
      zcfzbSeliceShow: false,
      zcfzbSeliceName: "最新",
      zcfzbSeliceList: [
        { name: "最新", key: "newly" },
        { name: "一季度", key: "first" },
        { name: "中报", key: "middle" },
        { name: "三季度", key: "third" },
        { name: "年报", key: "annal" },
      ],
      zcfzListAll: [],
      fzbZzcList: [],
      fzbZfzList: [],
      fzbfzlList: [],
      fzbAsOfDateList: [],
      fzbDom: null,
      zyfzText: "加载中",
      xjllbTitleList: [
        {
          title: "经营净额",
          id: "mananetr",
        },
        {
          title: "投资净额",
          id: "invnetcashflow",
        },
        {
          title: "融资净额",
          id: "finnetcflow",
        },
      ],
      handleCheckedXjllb: "mananetr",
      handleCheckedTitleXjllb: "经营净额",
      xjllb_sel: "newly",
      xjllbSeliceShow: false,
      xjllbSeliceName: "最新",
      xjllbSeliceList: [
        { name: "最新", key: "newly" },
        { name: "一季度", key: "first" },
        { name: "中报", key: "middle" },
        { name: "三季度", key: "third" },
        { name: "年报", key: "annal" },
      ],
      xjllText: "加载中",
      xjllDom: null,
      xjllbOriginalListAll: [],
      xjllbBarList: [],
      xjllbTbList: [],
      xjllbAsOfDateList: [],
    };
  },
  components: { Loading, Declare },
  mixins: [mixins],
  watch: {
    showTit: {
      handler(newval, old) {
        if (newval === "财务透视" && !this.affairQuery) {
          this.code = this.getUrlQuery("code");
          this.$nextTick(() => {
            this.getAffairData();
            this.getProfitData();
            this.getLiabilities();
            this.getCashData();
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取财务数据
    getAffairData: function () {
      let that = this;
      let obj = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/zyzb/" + that.code + "/homepage",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(obj), that.token)
        .then((res) => {
          that.affairQuery = true;
          if (
            res.resCode === "000000" &&
            res.resData["mapdata/zyzb/" + that.code + "/homepage"]
          ) {
            that.zyzbMgsyListAll = res.resData["mapdata/zyzb/" + that.code + "/homepage"];
            that.$nextTick(function () {
              that.zyzbMgsyListAll[that.zbToplistChecked][that.zb_sy_sel].forEach(
                function (item) {
                  that.zyzbMgsyList.unshift(item.value); //每股收益
                  that.zyzbTbList.unshift(item.yoy || 0); //每股收益 同比
                  that.zyzbAsOfDateList.unshift(item.bglx); //日期
                }
              );
              that.zyzb_mgsy();
            });
          } else {
            that.zyzbText = "暂无数据";
            that.zyzb_mgsy();
          }
        })
        .catch(() => {
          that.zyzbText = "暂无数据";
          that.zyzb_mgsy();
        });
    },
    //主要指标 切换选项
    handleZbToplist: function (i, name) {
      let that = this;
      that.zbToplistChecked = i;
      that.zbToplistCheckedName = name;
      that.zyzbMgsyList = [];
      that.zyzbAsOfDateList = [];
      that.zyzbTbList = [];
      that.$nextTick(function () {
        that.zyzbMgsyListAll[i][that.zb_sy_sel].forEach(function (item) {
          that.zyzbMgsyList.unshift(item.value); //数据值
          that.zyzbTbList.unshift(item.yoy || 0); //每股收益 同比
          that.zyzbAsOfDateList.unshift(item.bglx); //日期
        });
        that.zyzb_mgsy();
      });
    },
    //主要指标-图表
    zyzb_mgsy: function () {
      let that = this;
      if (!that.zyzbDom) {
        that.zyzbDom = document.getElementById("bar-zyzb")
          ? that.$echarts.init(document.getElementById("bar-zyzb"))
          : "";
      }

      if (!that.zyzbDom) {
        return false;
      }
      if (that.zyzbAsOfDateList.length == 0) {
        that.zyzbText = "暂无数据";
      }
      let data = [];
      let dataTypeStr = that.zbToplistChecked;
      let linLabelShow = false;
      if(dataTypeStr === "npmarginonsale" || dataTypeStr === "sgpmargin" || dataTypeStr === "roe" || dataTypeStr === "roa"){
        linLabelShow = true;
      }else{
        linLabelShow = false;
      }
      let zyzbMgsyList = that.zyzbMgsyList;
      for (let i = 0; i < zyzbMgsyList.length; i++) {
        let obj = {
          value: zyzbMgsyList[i],
          label: {
            color: "#999",
            show: true,
            position: zyzbMgsyList[i] >= 0 ? "top" : "bottom",
            formatter: linLabelShow ? zyzbMgsyList[i].toFixed(2) + "%" : zyzbMgsyList[i].toFixed(2),
          },
        };
        data.push(obj);
      }
      let option = {
        title: {
          show: that.zyzbAsOfDateList.length == 0, // 没数据才显示
          text: that.zyzbText,
          left: "center",
          top: "center",
          textStyle: {
            color: "#898e99",
            fontSize: 15,
            fontWeight: 400,
          },
        },
        color: ["#548FF7", "#FE8800"],
        grid: {
          left: 0,
          top: 15,
        },
        xAxis: {
          type: "category",
          splitLine: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#666",
              width: 0.5,
            },
          },
          axisTick: { show: false },
          axisLabel: {
            color: "#666",
            interval: 0,
            lineHeight: 15,
            align: "center",
            formatter: function (value, index) {
              return value.slice(0, 5) + "\r\n" + value.slice(5);
            },
          },
          data: that.zyzbAsOfDateList,
        },
        yAxis: [
          {
            type: "value",
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            show: false
          },
          {
            type: "value",
            axisLabel: { show: false },
            splitLine: { show: false },
            splitNumber: 4,
            axisLabel: {
              color: "#666",
              margin: 0,
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "35%",
            itemStyle: {},
            zlevel: -1,
            // label: {
            //   color: "#999",
            //   show: true,
            //   position: "top",
            //   formatter: function (num) {
            //     let newNum = num.value;
            //     // if(that.zbToplistChecked === 'basicepsn' ||that.zbToplistChecked === 'mgjzc'){
            //     return newNum.toFixed(2);
            //     // }else{
            //     //   return newNum.toFixed(2) + "%";
            //     // }
            //   },
            // },
            data: data,
          },
          {
            name: "同比",
            type: "line",
            yAxisIndex: 1,
            symbol: "circle",
            symbolSize: 7,
            zlevel: -1,
            lineStyle: {
              width: 1,
            },
            data: that.zyzbTbList,
          },
        ],
      };
      that.zyzbDom.setOption(option);
    },
    // 获取利润表
    getProfitData: function () {
      let that = this;
      let obj = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/lrb/" + that.code + "/homepage",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(obj), that.token)
        .then((res) => {
          if (
            res.resCode === "000000" &&
            res.resData["mapdata/lrb/" + that.code + "/homepage"]
          ) {
            that.lrbMgsyListAll = res.resData["mapdata/lrb/" + that.code + "/homepage"];
            that.$nextTick(function () {
              that.lrbMgsyListAll[that.handleChecked][that.lrb_sy_sel].forEach(function (
                item
              ) {
                that.lrbMgsyList.unshift(item.value); //数据值
                that.lrbTbList.unshift(item.yoy || 0); //利润表 同比
                that.lrbAsOfDateList.unshift(item.bglx); //日期
              });
              that.lrb();
            });
          } else {
            that.zyzbText = "暂无数据";
            that.lrb();
          }
        })
        .catch(() => {
          that.zyzbText = "暂无数据";
          that.lrb();
        });
    },
    //利润表
    lrb: function () {
      let that = this;
      if (!that.lrbDom) {
        that.lrbDom = document.getElementById("bar-lrb")
          ? that.$echarts.init(document.getElementById("bar-lrb"))
          : "";
      }
      if (!that.lrbDom) {
        return false;
      }
      if (that.lrbAsOfDateList.length == 0) {
        that.lrbText = "暂无数据";
      }
      let data = [];
      let lrbMgsyList = that.lrbMgsyList;
      for (let i = 0; i < lrbMgsyList.length; i++) {
        let obj = {
          value: lrbMgsyList[i],
          label: {
            color: "#999",
            show: true,
            position: lrbMgsyList[i] >= 0 ? "top" : "bottom",
            formatter: that.process(lrbMgsyList[i], 2),
          },
        };
        data.push(obj);
      }
      let option = {
        title: {
          show: that.lrbAsOfDateList.length == 0, // 没数据才显示
          text: that.lrbText,
          left: "center",
          top: "center",
          textStyle: {
            color: "#898e99",
            fontSize: 15,
            fontWeight: 400,
          },
        },
        color: ["#548FF7", "#FE8800"],
        grid: {
          left: 0,
          top: 15,
        },
        xAxis: {
          type: "category",
          splitLine: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#666",
              width: 0.5,
            },
          },
          axisTick: { show: false },
          axisLabel: {
            color: "#666",
            interval: 0,
            lineHeight: 15,
            align: "center",
            formatter: function (value, index) {
              return value.slice(0, 5) + "\r\n" + value.slice(5);
            },
          },
          data: that.lrbAsOfDateList,
        },
        yAxis: [
          {
            type: "value",
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            show: false,
            axisLabel: {
              color: "#666",
              margin: 0,
              formatter: "{value}",
            },
          },
          {
            type: "value",
            axisLabel: { show: false },
            splitLine: { show: false },
            splitNumber: 4,
            axisLabel: {
              color: "#666",
              margin: 0,
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "净利润(美元)",
            type: "bar",
            barWidth: "35%",
            // label: {
            //   color: "#999",
            //   show: true,
            //   position: "top",
            //   formatter: function (num) {
            //     return that.process(num.value, 2);
            //   },
            // },
            data: data,
          },
          {
            name: "同比",
            type: "line",
            yAxisIndex: 1,
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              width: 1,
            },
            data: that.lrbTbList,
          },
        ],
      };
      that.lrbDom.setOption(option);
    },
    //利润表点击切换
    handleCutLrb: function (i, t) {
      let that = this;
      that.handleChecked = i;
      that.handleCheckedTitle = t;
      that.lrbMgsyList = []; //数据值
      that.lrbTbList = []; //利润表 同比
      that.lrbAsOfDateList = []; //日期
      that.$nextTick(function () {
        that.lrbMgsyListAll[i][that.lrb_sy_sel].forEach(function (item) {
          that.lrbMgsyList.unshift(item.value); //数据值
          that.lrbTbList.unshift(item.yoy || 0); //利润表 同比
          that.lrbAsOfDateList.unshift(item.bglx); //日期
        });
        that.lrb();
      });
    },
    // 获取资产负债表数据
    getLiabilities: function () {
      let that = this;
      let obj = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/zcfz/" + that.code + "/homepage",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(obj), that.token)
        .then((res) => {
          if (
            res.resCode === "000000" &&
            res.resData["mapdata/zcfz/" + that.code + "/homepage"]
          ) {
            that.zcfzListAll = res.resData["mapdata/zcfz/" + that.code + "/homepage"];
            that.$nextTick(function () {
              // 总资产
              that.zcfzListAll.totasset[that.zcfzb_sel].forEach(function (i2) {
                that.fzbZzcList.unshift(i2.value); //总资产
                that.fzbAsOfDateList.unshift(i2.bglx); //日期
              });
              // 总负债
              that.zcfzListAll.totliab[that.zcfzb_sel].forEach(function (i2) {
                that.fzbZfzList.unshift(i2.value); //总负债
              });
              // 资产负债率
              that.zcfzListAll.debtassetsrate[that.zcfzb_sel].forEach(function (i2) {
                that.fzbfzlList.unshift(i2.value); //总负债
              });
              that.zcfzb();
            });
          } else {
            that.zyfzText = "暂无数据";
            that.zcfzb();
          }
        })
        .catch(() => {
          that.zyfzText = "暂无数据";
          that.zcfzb();
        });
    },
    zcfzb: function () {
      let that = this;
      if (!that.fzbDom) {
        that.fzbDom = document.getElementById("bar-fzb")
          ? that.$echarts.init(document.getElementById("bar-fzb"))
          : "";
      }
      if (!that.fzbDom) {
        return false;
      }
      if (that.fzbAsOfDateList.length == 0) {
        that.zcfzbText = "暂无数据";
      }
      let data = [];
      let fzbZzcList = that.fzbZzcList;
      for (let i = 0; i < fzbZzcList.length; i++) {
        let obj = {
          value: fzbZzcList[i],
          label: {
            color: "#999",
            show: true,
            position: fzbZzcList[i] >= 0 ? "top" : "bottom",
            formatter: that.process(fzbZzcList[i], 2),
          },
        };
        data.push(obj);
      }

      let fzbZfzData = [];
      let fzbZfzList = that.fzbZfzList;
      for (let i = 0; i < fzbZfzList.length; i++) {
        let obj = {
          value: fzbZfzList[i],
          label: {
            color: "#999",
            show: true,
            position: fzbZfzList[i] >= 0 ? "top" : "bottom",
            formatter: that.process(fzbZfzList[i], 2),
          },
        };
        fzbZfzData.push(obj);
      }

      let option = {
        title: {
          show: that.fzbAsOfDateList.length == 0, // 没数据才显示
          text: that.zcfzbText,
          left: "center",
          top: "center",
          textStyle: {
            color: "#898e99",
            fontSize: 15,
            fontWeight: 400,
          },
        },
        color: ["#548FF7", "#F5BA78", "#FE8800"],
        grid: {
          left: 0,
          top: 15,
        },
        xAxis: {
          type: "category",
          splitLine: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#666",
              width: 0.5,
            },
          },
          axisTick: { show: false },
          axisLabel: {
            color: "#666",
            interval: 0,
            lineHeight: 15,
            align: "center",
            formatter: function (value, index) {
              return value.slice(0, 5) + "\r\n" + value.slice(5);
            },
          },
          data: that.fzbAsOfDateList,
        },
        yAxis: [
          {
            type: "value",
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            show: false,
            axisLabel: {
              color: "#999",
              margin: 0,
              formatter: "{value}",
            },
          },
          {
            type: "value",
            axisLabel: { show: false },
            splitLine: { show: false },
            splitNumber: 4,
            axisLabel: {
              color: "#666",
              margin: 0,
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "总资产",
            type: "bar",
            barWidth: "35%",
            // label: {
            //   color: "#999",
            //   show: true,
            //   position: "top",
            //   formatter: function (num) {
            //     return that.process(num.value, 2);
            //   },
            // },
            data: data,
          },
          {
            name: "总负债",
            type: "bar",
            barWidth: "35%",
            barGap: 0,
            // label: {
            //   color: "#999",
            //   show: true,
            //   position: "top",
            //   formatter: function (num) {
            //     return that.process(num.value, 2);
            //   },
            // },
            data: fzbZfzData,
          },
          {
            name: "资产负债率",
            type: "line",
            yAxisIndex: 1,
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              width: 1,
            },
            data: that.fzbfzlList,
          },
        ],
      };
      that.fzbDom.setOption(option);
    },
    // 获取现金流量表
    getCashData: function () {
      let that = this;
      let obj = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/xjll/" + that.code + "/homepage",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(obj), that.token)
        .then((res) => {
          if (
            res.resCode === "000000" &&
            res.resData["mapdata/xjll/" + that.code + "/homepage"]
          ) {
            that.xjllbOriginalListAll =
              res.resData["mapdata/xjll/" + that.code + "/homepage"];
            that.$nextTick(function () {
              that.xjllbOriginalListAll[that.handleCheckedXjllb][that.xjllb_sel].forEach(
                function (item) {
                  that.xjllbBarList.unshift(item.value);
                  that.xjllbTbList.unshift(item.yoy || 0);
                  that.xjllbAsOfDateList.unshift(item.bglx);
                }
              );
              that.xjllb();
            });
          } else {
            that.xjllText = "暂无数据";
            that.xjllb();
          }
        })
        .catch(() => {
          that.xjllText = "暂无数据";
          that.xjllb();
        });
    },
    //现金流量表
    xjllb: function () {
      var that = this;
      if (!that.xjllDom) {
        that.xjllDom = document.getElementById("bar-llb")
          ? that.$echarts.init(document.getElementById("bar-llb"))
          : "";
      }
      if (!that.xjllDom) {
        return false;
      }
      if (that.xjllbAsOfDateList.length == 0) {
        that.xjllbText = "暂无数据";
      }
      let data = [];
      let xjllbBarList = that.xjllbBarList;
      for (let i = 0; i < xjllbBarList.length; i++) {
        let obj = {
          value: xjllbBarList[i],
          label: {
            color: "#999",
            show: true,
            position: xjllbBarList[i] >= 0 ? "top" : "bottom",
            formatter: that.process(xjllbBarList[i], 2),
          },
        };
        data.push(obj);
      }
      let option = {
        title: {
          show: that.xjllbAsOfDateList.length == 0, // 没数据才显示
          text: that.xjllbText,
          left: "center",
          top: "center",
          textStyle: {
            color: "#898e99",
            fontSize: 15,
            fontWeight: 400,
          },
        },
        color: ["#548FF7", "#FE8800"],
        grid: {
          left: 0,
          top: 35,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#666",
              width: 0.5,
            },
          },
          axisTick: { show: false },
          axisLabel: {
            color: "#666",
            interval: 0,
            lineHeight: 15,
            align: "center",
            formatter: function (value, index) {
              return value.slice(0, 5) + "\r\n" + value.slice(5);
            },
          },
          data: that.xjllbAsOfDateList,
        },

        yAxis: [
          {
            type: "value",
            show: false,
          },
          {
            type: "value",
            axisLabel: { show: false },
            splitLine: { show: false },
            splitNumber: 4,
            axisLabel: {
              color: "#666",
              margin: 0,
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "每股收益(美元)",
            type: "bar",
            barWidth: "35%",
            axisLabel: {
              color: "#999",
              margin: 0,
              formatter: "{value}%",
            },
            // label: {
            //   color: "#999",
            //   show: true,
            //   position: "top",
            //   formatter: function (num) {
            //     return that.process(num.value, 2);
            //   },
            // },
            // data: that.xjllbBarList,
            data: data,
          },
          {
            name: "同比",
            type: "line",
            yAxisIndex: 1,
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              width: 1,
            },
            data: that.xjllbTbList,
          },
        ],
      };
      that.xjllDom.setOption(option);
    },
    //现金流量表点击切换
    handleCutXjllb: function (i, t) {
      let that = this;
      that.handleCheckedXjllb = i;
      that.handleCheckedTitleXjllb = t;
      that.xjllbBarList = []; //数据值
      that.xjllbTbList = []; //利润表 同比
      that.xjllbAsOfDateList = []; //日期
      that.$nextTick(function () {
        that.xjllbOriginalListAll[i][that.xjllb_sel].forEach(function (item) {
          that.xjllbBarList.unshift(item.value); //数据值
          that.xjllbTbList.unshift(item.yoy || 0); //利润表 同比
          that.xjllbAsOfDateList.unshift(item.bglx); //日期
        });
        that.xjllb();
      });
    },
    // 主要指标感叹号跳转
    goZyzbLink: function () {
      window.location.href = window.config.zyzbLink + "?DZHSPECIAL=1";
    },
    // 跳转跟多页面
    goLinkMore: function (type) {
      window.location.href =
        "/cwts_more?code=" + this.code + "&type=" + type + "&DZHSPECIAL=9";
    },
    showSeliceAll: function () {
      this.zbSelectShow = false;
      this.lrbSeliceShow = false;
      this.zcfzbSeliceShow = false;
      this.xjllbSeliceShow = false;
    },
    //主要指标
    seliceZbSy: function (item) {
      let that = this;
      that.zb_sy_sel = item.key;
      that.zbSelectShow = false;
      that.zbSeliceName = item.name;
      that.zyzbMgsyList = [];
      that.zyzbAsOfDateList = [];
      that.zyzbTbList = [];
      that.zyzbMgsyListAll[that.zbToplistChecked][item.key].forEach(function (item) {
        that.zyzbMgsyList.unshift(item.value); //每股收益
        that.zyzbTbList.unshift(item.yoy || 0); //每股收益 同比
        that.zyzbAsOfDateList.unshift(item.bglx); //日期
      });
      that.zyzb_mgsy();
    },
    // 利润表
    seliceLrb: function (item) {
      let that = this;
      that.lrb_sy_sel = item.key;
      that.lrbSeliceShow = false;
      that.lrbSeliceName = item.name;
      that.lrbMgsyList = [];
      that.lrbAsOfDateList = [];
      that.lrbTbList = [];
      that.lrbMgsyListAll[that.handleChecked][item.key].forEach(function (item) {
        that.lrbMgsyList.unshift(item.value); //每股收益
        that.lrbTbList.unshift(item.yoy || 0); //每股收益 同比
        that.lrbAsOfDateList.unshift(item.bglx); //日期
      });
      that.lrb();
    },
    // 资产负债表
    seliceZcfzb: function (item) {
      let that = this;
      that.zcfzbSeliceShow = false;
      that.zcfzbSeliceName = item.name;
      that.zcfzb_sel = item.key;
      that.fzbZzcList = [];
      that.fzbAsOfDateList = [];
      that.fzbZfzList = [];
      that.fzbfzlList = [];
      that.$nextTick(function () {
        // 总资产
        that.zcfzListAll.totasset[item.key].forEach(function (i2) {
          that.fzbZzcList.unshift(i2.value); //总资产
          that.fzbAsOfDateList.unshift(i2.bglx); //日期
        });
        // 总负债
        that.zcfzListAll.totliab[item.key].forEach(function (i2) {
          that.fzbZfzList.unshift(i2.value); //总负债
        });
        // 资产负债率
        that.zcfzListAll.debtassetsrate[item.key].forEach(function (i2) {
          that.fzbfzlList.unshift(i2.value); //总负债
        });
        that.zcfzb();
      });
    },
    // 现金流量表
    seliceXjllb: function (item) {
      let that = this;
      that.xjllb_sel = item.key;
      that.xjllbSeliceShow = false;
      that.xjllbSeliceName = item.name;
      that.xjllbBarList = []; //数据值
      that.xjllbTbList = []; //利润表 同比
      that.xjllbAsOfDateList = []; //日期
      that.$nextTick(function () {
        that.xjllbOriginalListAll[that.handleCheckedXjllb][item.key].forEach(function (
          item
        ) {
          that.xjllbBarList.unshift(item.value); //数据值
          that.xjllbTbList.unshift(item.yoy || 0); //利润表 同比
          that.xjllbAsOfDateList.unshift(item.bglx); //日期
        });
        that.xjllb();
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
